
import { WorldCountry } from '../types';
import { polandExpanded } from './polandExpansion';
import { romaniaExpanded } from './romaniaExpansion';
import { bulgariaExpanded } from './bulgariaExpansion';
import { croatiaExpanded } from './croatiaExpansion';

export const finalEuropeCountries7: WorldCountry[] = [
  polandExpanded,
  romaniaExpanded,
  bulgariaExpanded,
  croatiaExpanded
];
